import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as xml2js from 'xml2js';
import { Subscription } from 'rxjs';
import { PreviewService } from 'netsocial-lib/src/app/services/preview/preview.service';
import { ErrorService } from 'netsocial-posting/src/app/services/error/error.service';

export interface RSSWrapper {
  rss: RSSObject;
}

export interface RSSObject {
  $: {
    version: string;
    'xmlns:atom': string;
  };
  channel: Array<RSSChannel>;
}

export interface RSSChannel {
  'atom:link': string[];
  description: string[];
  image: RSSImage[];
  item: RSSItem[];
  language: string[];
  lastBuildDate: Date;
  link: string[];
  title: string[];
}

export interface RSSImage {
  link: string[];
  title: string[];
  url: string[];
}

export interface RSSItem {
  category?: string[];
  description: string[];
  guid?: unknown;
  link: string[];
  pubDate?: Date;
  title: string[];
  previewImage?: string;
}

@Component({
  selector: 'netsocial-insights',
  templateUrl: './netsocial-insights.component.html',
  styleUrls: ['./netsocial-insights.component.scss'],
})
export class NetsocialInsightsComponent implements OnInit, OnDestroy {
  constructor(
    private http: HttpClient,
    private previewService: PreviewService,
    private errorService: ErrorService
  ) {}

  items: RSSItem[] = [];

  insightsSubscription?: Subscription;

  loading: boolean;

  ngOnInit(): void {
    this.loading = true;
    this.loadInsights();
  }

  ngOnDestroy(): void {
    this.insightsSubscription?.unsubscribe();
  }

  loadInsights(): void {
    this.insightsSubscription = this.http
      .get('https://www.netsocialapp.com/feed/', {
        observe: 'body',
        responseType: 'text',
      })
      .subscribe(
        (data) => {
          xml2js.parseString(data, (_err, result: RSSWrapper) => {
            if (result.rss.channel.length) {
              this.items = result.rss.channel[0].item;
            }
            this.insightsSubscription = undefined;
          });
          if (this.items?.length > 3) {
            this.items = this.items.splice(0, 3);
          }
          this.getPreviews();
        },
        () => {
          this.errorService.toastError('components.netsocialInsights.errors.insights');
        }
      );
  }
  async getPreviews(): Promise<void> {
    const promises: Promise<unknown>[] = [];
    this.items.forEach((item) => {
      const promise = new Promise(() => {
        this.errorService.resolve(
          this.previewService.getLinkPreview({
            url: item.link[0],
          }),
          {
            successCallback: (linkPreview) => {
              item.previewImage = linkPreview.image;
              this.loading = false;
            },
          }
        );
      });
      promises.push(promise);
    });
    if (promises) {
      await Promise.all(promises);
    } else {
      this.loading = false;
    }
  }
}
